import { useSelector } from 'react-redux';
import { getLoggedUser } from './logged-user.state';

export const useLoggedUser = () => {
    const loggedUser = useSelector(getLoggedUser);

    return {
        loggedUser,
    };
};
